export interface ContactModel {
    customer: Customer;
    project: Project;
    preferredContact: ContactMethod;
}

export interface Project {
   description: string;
   images: File[];
}

interface Customer {
    name: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    zip: string;
}
export enum ContactMethod {   
    Email = "Email",
    Phone = "Phone",
    Text = "Text",
}

    